import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function changePassword(body: object): Promise<ApiResponse> {
  return Axios.put("v1/accounts/change_password", body);
}
